var _excluded = ["onClick", "icon"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../../Button';
var ButtonIcon = styled(Button.Icon)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref) {
  var heading = _ref.theme.yoga.components.heading;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      width: ", "px;\n      height: ", "px;\n\n      :not(:last-of-type) {\n        margin-right: ", "px;\n      }\n    "])), heading.button.width, heading.button.height, heading.button.marginRight);
});

var RightButton = function RightButton(_ref2) {
  var onClick = _ref2.onClick,
      icon = _ref2.icon,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(ButtonIcon, _extends({}, props, {
    icon: icon,
    inverted: true,
    onClick: onClick
  }));
};

RightButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.elementType.isRequired
};
RightButton.displayName = 'Heading.RightButton';
export default RightButton;